<template>
  <div class="hello">

    <div v-if="success">
      <h1 class="is-size-2 has-text-centered">{{ $t('This form has been sent successfully.') }}</h1>
    </div>

    <form v-else @submit.prevent="submit" novalidate>
      <div class="field">
        <label class="label">{{ $t('Venue Name') }}<span class="required">*</span></label>
        <div class="control">
          <input v-model="venue" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.venue.$error">{{ $t('nec') }}</div>
      </div>

      <label class="label">{{ $t('Venue type') }} <span class="required">*</span></label>
      <div v-for="(type,i) in venueTypes" :key="i" class="field">
        <input class="is-checkradio" :id="`venueTypeCheckbox_${i}`" type="checkbox" :name="`venueTypeCheckbox_${i}`" v-model="type.checked">
        <label :for="`venueTypeCheckbox_${i}`">{{ type.value }}</label>
      </div>
      <div class="has-text-error-message" v-if="v$.venueTypes.$error">{{ $t('atLeastOne') }}</div>

      <label class="label">{{ $t('Address') }}</label>
      <div class="field">
        <label class="label">{{ $t('Country') }} <span class="required">*</span></label>
        <div class="select is-fullwidth">
          <select v-model="country">
            <option v-for="country in countries" :value="country.value" :key="country.label">
              {{ country.label }}
            </option>
          </select>
        </div>
        <div class="has-text-error-message" v-if="v$.country.$error">{{ $t('nec') }}</div>

      </div>

<!--      <div class="field">-->
<!--        <label class="label">{{ $t('Company') }}</label>-->
<!--        <div class="control">-->
<!--          <input v-model="company" type="text" class="input">-->
<!--        </div>-->
<!--      </div>-->

      <div class="field">
        <label class="label">{{ $t('Address') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="address" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.address.$error">{{ $t('nec') }}</div>
      </div>

      <div class="fields ">
        <div class="columns">
          <div class="column is-4">
            <div class="field">
              <label class="label">{{ $t('Postal code') }} <span class="required">*</span></label>
              <div class="control">
                <input v-model="postalCode" type="text" class="input">
              </div>
              <div class="has-text-error-message" v-if="v$.postalCode.$error">{{ $t('nec') }}</div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">{{ $t('City') }} <span class="required">*</span></label>
              <div class="control">
                <input v-model="city" type="text" class="input">
              </div>
              <div class="has-text-error-message" v-if="v$.city.$error">{{ $t('nec') }}</div>
            </div>
          </div>
          <div class="column is-4">
            <div class="field">
              <label class="label">{{ $t('Province') }} <span class="required">*</span></label>
              <div class="control">
                <input v-model="province" type="text" class="input">
              </div>
              <div class="has-text-error-message" v-if="v$.province.$error">{{ $t('nec') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Website') }}</label>
        <div class="control">
          <input v-model="website" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.website.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Telephone') }}</label>
        <div class="control">
          <input v-model="telefonoV" type="tel" class="input" placeholder="+44">
          <div class="has-text-error-message" v-if="v$.telefonoV.$error">{{ tel }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{
            $t('Please provide a brief description of your venue, highlighting the remarkable dry sherries you offer. If applicable, we would love to hear your expert recommendation for a perfect sherry pairing.')
          }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="shortDesc" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.shortDesc.$error">{{ $t('nec') }}</div>
      </div>

      <label class="label">{{ $t('Please select what style of sherry wines you have available') }}</label>
      <div v-for="(type,i) in wineStyles" :key="i" class="field checker" :class="'checker'+i">
        <input class="is-checkradio" :id="`wineStyleCheckbox1_${i}`" type="checkbox" :name="`wineStyleCheckbox1_${i}`" v-model="type.checked">
        <label :for="`wineStyleCheckbox1_${i}`">{{ type.value }}</label>
      </div>

<!--      <label class="label">{{ $t('Our recommended') }} <span class="required">*</span></label>-->
<!--      <div class="field">-->
<!--        <input class="is-checkradio" id="exampleRtlRadio1" type="radio" name="exampleRtlRadio1" value="Sherry Wine Pairing" v-model="recommended">-->
<!--        <label for="exampleRtlRadio1">{{ $t('Sherry Wine Pairing') }}</label>-->
<!--      </div>-->
<!--      <div class="field">-->
<!--        <input class="is-checkradio" id="exampleRtlRadio2" type="radio" name="exampleRtlRadio2" value="Sherry Cocktail" v-model="recommended">-->
<!--        <label for="exampleRtlRadio2">{{ $t('Sherry Cocktail') }}</label>-->
<!--      </div>-->
<!--      <div class="has-text-error-message" v-if="v$.recommended.$error">{{ $t('nec') }}</div>-->

<!--      <div class="field">-->
<!--        <label class="label">{{ $t('Title of sherry pairing - cocktail') }}</label>-->
<!--        <div class="control">-->
<!--          <input v-model="titleOfSherryPairing" type="text" class="input">-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="field">-->
<!--        <label class="label">{{ $t('Please provide a short description of your venues most popular or recommended sherry wine pairing or sherry cocktail') }} <span class="required">*</span></label>-->
<!--        <div class="control">-->
<!--          <textarea v-model="recommendedDesc" class="textarea"></textarea>-->
<!--        </div>-->
<!--        <div class="has-text-error-message" v-if="v$.recommendedDesc.$error">{{ $t('nec') }}</div>-->
<!--      </div>-->
      <label class="label">{{ $t('Please include an image of your venue, or of your dry sherries available or a sherry pairing from your menu') }} <span class="required">*</span></label>
      <div class="uploader uploader1">
        <file-upload v-show="files.length == 0"
                     input-id="file1"
                     class="has-text-centered "
                     extensions="jpg,jpeg,png"
                     accept="image/png,image/jpeg"
                     post-action="/api/upload-image/"
                     ref="file1"
                     v-model="files"
                     :headers="{'X-CSRFTOKEN': csrf}"
                     :drop="'.uploader1'"
                     :size="1024 * 1024 *4"
                     @input-filter="inputFilter"
                     @input-file="inputFile"
        >
          <div>
            <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB.') }}
              <br>
              {{ $t('Allowed file types: gif jpg jpeg.') }}
            </div>
          </div>

        </file-upload>
        <div v-if="files.length > 0">
          <div class="columns is-gapless">
            <div class="column is-4">
              <img
                  :src="files.length ? files[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                  class="upload-photo"/>
            </div>
            <div class="column">
              <div>
                <p class="pb-5">{{ files[0].name }}</p>

                <button
                    style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                    class="button is-small is-uppercase has-text-weight-bold has-text-white" @click="files=[]"
                    type="button">X
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="has-text-error-message" v-if="v$.f1.$error">{{ $t('nec') }}</div>
      </div>


      <label class="label">{{ $t('Please include 1-5 images of your venue and or Sherry Menu and Pairings') }}</label>
            <div class="has-text-error-message" v-if="v$.whereBuy.$error">You must upload between 2 and 5 products, and complete their information</div>

      <div class="uploadEl" v-for="(wb,i) in whereBuy">


        <div :class="'uploaderx'+i" class="uploader">
          <file-upload v-show="whereBuy[i].files.length == 0"
                       :input-id="'fileupload'+i"
                       class="has-text-centered "
                       extensions="jpg,jpeg,png"
                       accept="image/png,image/jpeg"
                       post-action="/api/upload-image/"
                       :ref="'fileupload'+i"
                       v-model="whereBuy[i].files"
                       :headers="{'X-CSRFTOKEN': csrf}"
                       :drop="'.uploaderx'+i"
                       :size="1024 * 1024 *4"
                       @input-filter="inputFilter"
                       @input-file="inputFile3"
          >
            <!-- :multiple="true" -->
            <div>
              <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB.') }}
                <br>
                {{ $t('Allowed file types: gif jpg jpeg.') }}
              </div>
            </div>

          </file-upload>

          <div v-if="whereBuy[i].files.length > 0">
            <div class="columns is-gapless">
              <div class="column is-4">
                <img
                    :src="whereBuy[i].files[0] ? whereBuy[i].files[0].thumb: 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                    class="upload-photo"/>
              </div>
              <div class="column">
                <div>
                  <p class="pb-5">{{ whereBuy[i].files[0].name }}</p>

                  <button
                      style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                      class="button is-small  is-uppercase has-text-weight-bold has-text-white" @click="whereBuy[i]={files:[]}"
                      type="button">X
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

<!--        <pre>{{whereBuy}}</pre>-->


        <div class="field">
          <label class="label">{{ $t('Title') }}</label>
          <div class="control">
            <input v-model="whereBuy[i].title" type="url" class="input" placeholder="https://">
            <!--          <div class="has-text-error-message" v-if="v$.twitter.$error">{{ $t('url') }}</div>-->
          </div>
        </div>


        <div class="field">
          <label class="label">{{ $t('Url') }}</label>
          <div class="control">
            <input v-model="whereBuy[i].url" type="url" class="input" placeholder="https://">
            <!--          <div class="has-text-error-message" v-if="v$.twitter.$error">{{ $t('url') }}</div>-->
          </div>
        </div>
<div class="has-text-right">
        <button class="button is-small" v-if="i>1" type="button" @click="removeFile(i)">Remove</button>
</div>
      </div>

      <button class="button is-small" v-if="whereBuy.length<5" type="button" @click="addFile">+</button>

      <label class="label">{{ $t('Please subscribe me to your newsletter') }}</label>
      <div class="field">
        <input v-model="newsletter" class="is-checkradio" id="newsletterCheckbox" type="checkbox"
               name="newsletterCheckbox"
               checked="checked">
        <label for="newsletterCheckbox">{{ $t('I accept to recieve promotions, offers and commercial communications') }}</label>
      </div>

<!--      <div class="field">-->
<!--        <label class="label">{{ $t('I accept to receive promotions, offers and commercial communications') }}</label>-->
<!--        <div class="control">-->
<!--          <input v-model="contactEmail" type="email" class="input">-->
<!--          <div class="has-text-error-message" v-if="v$.contactEmail.$error">{{ $t('email') }}</div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="field">
        <label class="label">{{ $t('Url for Facebook (not for publication)') }}</label>
        <div class="control">
          <input v-model="facebook" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.facebook.$error">{{ $t('url') }}</div>
        </div>
      </div>

<!--      <div class="field">-->
<!--        <label class="label">{{ $t('Handle for Twitter (not for publication)') }}</label>-->
<!--        <div class="control">-->
<!--          <input v-model="twitter" type="url" class="input" placeholder="https://">-->
<!--          <div class="has-text-error-message" v-if="v$.twitter.$error">{{ $t('url') }}</div>-->
<!--        </div>-->
<!--      </div>-->

      <div class="field">
        <label class="label">{{ $t('Handle for instagram (not for publication)') }}</label>
        <div class="control">
          <input v-model="instagram" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.instagram.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <br>
      <div class="field">
        <input v-model="termsAndConditions" class="is-checkradio" id="termsAndConditionsCheckbox" type="checkbox" name="termsAndConditionsCheckbox"
               checked="checked">
        <label class="termsAndConditionsCheckbox" for="termsAndConditionsCheckbox">{{ $t('I accept the conditions laid out in the') }} <a style="color: #D37700; text-decoration: underline"
                                                                                                       href="https://www.sherry.wine/es/legal">{{ $t('Legal Notice') }}</a>
          {{ $t('AND') }}
          <a style="color: #D37700; text-decoration: underline"
             href="https://www.sherry.wine/es/legal">{{ $t('Privacy Policy') }}</a>
          <span class="required"> *</span></label>
        <div class="has-text-error-message" v-if="v$.termsAndConditions.$error">{{ $t('nec') }}{{ $t('nec') }}</div>
      </div>

      <div class="pt-5">
        <button style="background: #D37700; font-size: 14px; padding: 20px 40px;border: none"
                type="submit" class="button is-uppercase has-text-white has-text-weight-bold ">{{ $t('Send') }}
        </button>
      </div>

    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {required, email, integer, url, helpers, requiredIf} from '@vuelidate/validators';
import VueUploadComponent from 'vue-upload-component';
import axios from "axios";

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

const phone = helpers.regex(/^\+34[0-9 ]{5,10}$/);
//const urlx = helpers.regex(/^http.*$/);

const time = helpers.regex(/^(0?[1-9]|1[012]):[0-5][0-9]$/);

import FileComponent from "./FileComponent.vue";

const hasddress = (value, siblings) => {
  console.log("siblings");
  console.log(siblings);
  return true && value;
};

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export default {

  setup() {
    return {v$: useVuelidate()};
  },
  name: 'Events',
  components: {
    'file-upload': VueUploadComponent,
    'file-component': FileComponent,
  },
  props: {
    csrf: String,
    lang: String,
    waglocale: String,
    venuetypesuk: Object,
    winestyles: Object,
  },
  data() {
    return {
      success: false,

      files: [],
      files2: [],

      whereBuy: [
        {
          files: [],
          title: "",
          url: ""
        },
        {
          files: [],
          title: "",
          url: ""
        }
      ],

      wbProto: {
        files: [],
        title: "",
        url: ""
      },

      f1: null,
      f2: null,

      nec: "Este campo es necesario",
      mail: "Este campo tiene que ser un email",
      url: "Este campo tiene que ser un url",
      tel: "Este campo tiene que ser telefono",
      cpe: "Este campo tiene que un código postal",

      venue: '',
      venueTypes: [],

      country: null,
      company: '',
      address: '',
      postalCode: '',
      city: '',
      province: '',
      website: '',
      telefonoV: '',
      shortDesc: '',

      wineStyles: [],

      recommended: 'Sherry Wine Pairing',
      titleOfSherryPairing: '',
      recommendedDesc: '',

      newsletter: false,
      contactEmail: '',
      instagram: '',
      facebook: '',
      twitter: '',
      termsAndConditions: null,
    };
  },
  validations() {
    function termsAgreed() {
      return this.termsAndConditions;
    }

    function atLeastOneVenue() {
      for (const item of this.venueTypes) {
        if (item.checked)
          return true;
      }
      return false;
    }

    function checkWhereBuy() {
      let returnVal = true
      this.whereBuy.forEach(o => {
        if (o.files.length < 1) returnVal = false;
        if (o.url == '') returnVal = false;
        if (o.title == '') returnVal = false;
      });
      return returnVal;
    }


    return {
      f1: {required},
      venue: {required},
      venueTypes: {atLeastOneVenue},
      whereBuy: {checkWhereBuy},
      country: {required},
      address: {required},
      postalCode: {required},
      city: {required},
      province: {required},
      website: {url},
      telefonoV: {requiredIfTelefonoV: requiredIf(this.enoturismo2), integer},
      shortDesc: {required},
      // recommended: {required},
      // recommendedDesc: {required},
      // contactEmail: {email},
      facebook: {url},
      instagram: {url},
      // twitter: {url},
      termsAndConditions: {required, termsAgreed}
    };
  },
  methods: {
    addFile() {
      this.whereBuy.push(this.wbProto);
    },
    removeFile(i) {
      console.log("i", i);
      this.whereBuy.splice(i, 1);
    },
    doSuccess() {
      this.success = true;
      //this.scrollToClass('event')
      window.scrollTo(0, 0);
    },

    async submit() {
      const result = await this.v$.$validate();
      if (!result) {
        console.log(result);
        console.log("validation error");
        // notify user form is invalid
        this.scrollToClass('has-text-error-message');
        return;
      }

      let whereToBuy = [];

      this.whereBuy.forEach(o =>
          whereToBuy.push(
              {
                image:o.files[0].response.id,
                title:o.title,
                url:o.url
              }
          )
      )

      const formData = {
        venue: this.venue,
        venueTypesSherryUk: this.venueTypes,

        country: this.country,
        company: this.company,
        address: this.address,
        postalCode: this.postalCode,
        city: this.city,
        province: this.province,
        website: this.website,
        telefonoV: this.telefonoV,
        shortDesc: this.shortDesc,

        wineStyles: this.wineStyles,

        recommended: this.recommended,
        titleOfSherryPairing: this.titleOfSherryPairing,
        recommendedDesc: this.recommendedDesc,

        newsletter: this.newsletter,
        contactEmail: this.contactEmail,
        instagram: this.instagram,
        facebook: this.facebook,
        twitter: this.twitter,
        termsAndConditions: this.termsAndConditions,
        whereToBuy:whereToBuy,

        f1: this.f1,

        waglocale: this.waglocale
      };

      axios.post("/api/sherryspot/", formData)
          .then((res) => {
            console.log(res);
            this.doSuccess();
            // this.success = true;
          })
          .catch((err) => {
            alert("Ha habido un error, contacta con soporte");
          });

    },

    scrollToClass(className) {
      const el = this.$el.getElementsByClassName('has-text-error-message')[0];
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
      }
    },
    async inputFile(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file1.active) {
          this.$refs.file1.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },
    async inputFile2(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file2.active) {
          this.$refs.file2.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },

    async inputFile3(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        newFile.active = true
      }
    },


    inputFilter(newFile, oldFile, prevent) {

      if (newFile && !oldFile) {

        if (!newFile.name.match((/.png|.jpg|.gif$/))) {
          alert("The file must be png or jpg");
          return prevent();
        }
      }

      if (newFile.size > 1024 * 1024 * 4) {
        alert("The file must be less than 2 MB");
        return prevent();
      }

      if (newFile && newFile.error === "" && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        let URL = (window.URL || window.webkitURL);
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    },
  },
  computed: {
    countries() {
      const list = countries.getNames('en', {select: 'official'});
      return Object.keys(list).map((key) => ({value: key, label: list[key]}));
    }
  },
  watch: {
    files: {
      handler: function (files, oldVal) {
        if (files.length > 0 && files[0].response && files[0].response.id) {
          this.f1 = files[0].response.id;
          return;
        }
        this.f1 = null;

      },
      deep: true
    },
    files2: {
      handler: function (files2, oldVal) {
        if (files2.length > 0 && files2[0].response && files2[0].response.id) {
          this.f2 = files2[0].response.id;
          return;
        }
        this.f2 = null;
      },
      deep: true
    }
  },
  mounted() {
    this.$i18n.locale = this.lang;

    Object.entries(JSON.parse(this.venuetypesuk)).forEach(item => {
      this.venueTypes.push({
        'id': item[0],
        'value': item[1],
        'checked': false
      });
    });

    Object.entries(JSON.parse(this.winestyles)).forEach(item => {
      this.wineStyles.push({
        'id': item[0],
        'value': item[1],
        'checked': false
      });
    });
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.is-checkradio[type=checkbox] + label::after, .is-checkradio[type=checkbox] + label:after {
  color: #292624;
  border-color: #292624;

}

.is-checkradio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before {
  background: #FBF5EF;

}


label.label {
  margin-top: 30px;
}

dio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before, .is-checkradio[type=radio] + label::before, .is-checkradio[type=radio] + label:before {
  border-color: #FBF5EF;
}

.is-checkradio[type=checkbox]:hover:not([disabled]) + label::before, .is-checkradio[type=checkbox]:hover:not([disabled]) + label:before, .is-checkradio[type=radio]:hover:not([disabled]) + label::before, .is-checkradio[type=radio]:hover:not([disabled]) + label:before {
  border-color: #d37700 !important;

}

.uploader {
  padding: 30px;
  background: #FBF5EF;
  border: 1px dashed #C3B193;
  border-radius: 10px;
  width: 100%;
  display: block;

}

.has-text-error-message {
  background: darkred;
  color: white !important;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: 600;
  margin-top: 3px;
  display: block;
}

.upload-photo {
  width: 90%;
  height: auto;
  display: block;

}

.uploadEl {
  border: 1px dotted #C3B193;
  padding: 10px;
  margin-bottom: 10px;
}

.button.is-small{
  font-size: 12px !important;
  padding:16px 20px !important
}


.checker5,
.checker6,
.checker7,
.checker8,
.checker9,
.checker10,

.checker:nth-child(2){
  display:none !important;
}

.termsAndConditionsCheckbox a{
  display:contents !important;
}

</style>